import React from "react"
import {formatTextTestIds} from "@next/utils"
import {ButtonContainer, ImageContainer, Img} from "./component"
import {DefaultTemplateCountryLangSelectorButtonContainerType} from "../.."

export const ClubCountryLangSelectorButtonContainer = ({
    applyMarginCompensation,
    openDrawer,
    territory,
    iconUrl,
}: DefaultTemplateCountryLangSelectorButtonContainerType) => {
    return (
        <ButtonContainer
            className="countrylangselector"
            data-testid={formatTextTestIds("header-country-lang-selector")}
            applyMarginCompensation={applyMarginCompensation}
        >
            <ImageContainer onClick={() => openDrawer(true)}>
                <Img alt={territory} src={iconUrl} data-testid={formatTextTestIds("header-country-lang-flag")} />
            </ImageContainer>
        </ButtonContainer>
    )
}

export default ClubCountryLangSelectorButtonContainer
